import React from "react";
import { ReactComponent as Back } from "../../assets/icons/arrow_forward-24px.svg";
import { useHistory } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/icons/Group 1.svg";
const PhoneHeader = ({ text, usage }) => {
  const history = useHistory();
  return (
    <div
      className="PhoneHeader"
      style={{ backgroundColor: usage ? "#f9f9f9" : "#fff" }}
    >
      <Back onClick={() => history.goBack()} />
      <span>{text}</span>
      <Logo />
    </div>
  );
};

export default PhoneHeader;
